export default __webpack_public_path__ + "static/media/bathroom.c7243129.jpg";